<template>
  <div class="home-enterprise-mian">
    <div class="enterprise-name-mian">
      <img class="enterprise-name-ico" src="../../assets/homeNew/content13.png" />
      <div class="enterprise-name-right">
        <div class="name">{{ newData.companyBaseInfo.name && newData.companyBaseInfo.name != '' ?
          newData.companyBaseInfo.name :
          '-' }}</div>
        <div class="enterprise-code">统一社会信用代码：{{ newData.companyBaseInfo.socialCreditCode &&
          newData.companyBaseInfo.socialCreditCode != '' ? newData.companyBaseInfo.socialCreditCode :
          '-'
        }}
        </div>
      </div>
    </div>

    <el-row :gutter="10">
      <el-col :xs="12" :sm="12" :lg="12">
        <div class="enterprise-value">法定代表人：{{ newData.companyBaseInfo.legalRepresentative &&
          newData.companyBaseInfo.legalRepresentative != '' ? newData.companyBaseInfo.legalRepresentative : '-' }}
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12">
        <div class="enterprise-value">企业邮箱：{{ newData.companyBaseInfo.companyMailbox &&
          newData.companyBaseInfo.companyMailbox
          != '' ?
          newData.companyBaseInfo.companyMailbox : '-' }}</div>
      </el-col>
    </el-row>


    <el-row :gutter="10">
      <el-col :xs="12" :sm="12" :lg="12">
        <el-row>
          <el-col :xs="24" :sm="24" :lg="24">
            <div class="enterprise-value">注册资金：{{ newData.companyBaseInfo.registeredFund &&
              newData.companyBaseInfo.registeredFund != '' ?
              newData.companyBaseInfo.registeredFund : '-' }} 万元人民币
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24">
            <div class="enterprise-value">成立时间：{{ newData.companyBaseInfo.establishedDate &&
              newData.companyBaseInfo.establishedDate != '' ?
              newData.companyBaseInfo.establishedDate.split(' ')[0] : '-' }}
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24">
            <div class="enterprise-value">联系方式：{{ newData.companyBaseInfo.companyTel && newData.companyBaseInfo.companyTel
              != ''
              ?
              newData.companyBaseInfo.companyTel : '-' }}
            </div>
          </el-col>

        </el-row>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12">
        <div class="enterprise-value2">地址：{{ newData.companyBaseInfo.registeredAddress &&
          newData.companyBaseInfo.registeredAddress != '' ?
          newData.companyBaseInfo.registeredAddress : '-' }}</div>
      </el-col>
    </el-row>


    <div class="warning-ul">
      <div class="warning-li">
        <div class="warning-item">
          <span class="name">{{ newData.employeeCount && newData.employeeCount != '' ?
            newData.employeeCount : '0' }}</span>
          <span class="vale">企业员工</span>
        </div>
      </div>

      <div class="warning-li">
        <div class="warning-item">
          <span class="name warning-color-FF7301">{{ newData.dsMajorHazardsCount && newData.dsMajorHazardsCount != '' ?
            newData.dsMajorHazardsCount : '0' }}</span>
          <span class="vale">危险源</span>
        </div>
      </div>

      <div class="warning-li">
        <div class="warning-item">
          <span class="name warning-color-FFCC01">{{ newData.riskCount && newData.riskCount != '' ?
            newData.riskCount : '0' }}</span>
          <span class="vale">风险点</span>
        </div>
      </div>

      <div class="warning-li">
        <div class="warning-item">
          <span class="name warning-color-00DC62">{{ newData.troubleshootPlanCount && newData.troubleshootPlanCount != ''
            ?
            newData.troubleshootPlanCount : '0' }}</span>
          <span class="vale">隐患任务</span>
        </div>
      </div>

      <div class="warning-li">
        <div class="warning-item">
          <span class="name warning-color-00E4FF">{{ newData.tbHiddenGovernCount && newData.tbHiddenGovernCount != '' ?
            newData.tbHiddenGovernCount : '0' }}</span>
          <span class="vale">隐患治理</span>
        </div>
      </div>
    </div>

    {{ showData }}
  </div>
</template>

<script>
import resize from './mixins/resize'
import { parseNumber } from '@/utils'
export default {
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      newData: {
        companyBaseInfo: {

        }
      }
    }
  },
  watch: {

  },
  computed: {
    showData() {
      this.newData = JSON.parse(JSON.stringify(this.item))
      this.newData.employeeCount = 0
      this.newData.dsMajorHazardsCount = 0
      this.newData.riskCount = 0
      this.newData.troubleshootPlanCount = 0
      this.newData.tbHiddenGovernCount = 0
      return ''
    }
  },
  created() {

    setInterval(() => {
      this.newData.employeeCount = this.trendsHandle(this.newData.employeeCount, this.item.employeeCount)
      this.newData.dsMajorHazardsCount = this.trendsHandle(this.newData.dsMajorHazardsCount, this.item.dsMajorHazardsCount)
      this.newData.riskCount = this.trendsHandle(this.newData.riskCount, this.item.riskCount)
      this.newData.troubleshootPlanCount = this.trendsHandle(this.newData.troubleshootPlanCount, this.item.troubleshootPlanCount)
      this.newData.tbHiddenGovernCount = this.trendsHandle(this.newData.tbHiddenGovernCount, this.item.tbHiddenGovernCount)
    }, 50);
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    // 动态处理
    trendsHandle(currentRate, rate) {
      if (!rate || rate == '' || isNaN(Number(rate))) {
        return '-'
      }
      rate = parseNumber(Number(rate))

      if (isNaN(Number(currentRate))) {
        currentRate = 0;
      } else {
        currentRate = parseNumber(Number(currentRate));
      }

      if (currentRate < rate) {
        if (parseInt(rate) == currentRate) {
          currentRate = parseNumber(currentRate + (rate - parseInt(rate)));
        } else {
          currentRate = parseNumber(currentRate + 1);
        }

        return currentRate
      } else {
        return rate
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-enterprise-mian {
  width: 100%;

  .enterprise-name-mian {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 40px;

    .enterprise-name-ico {
      width: 54px;
      height: 54px;
      margin-right: 20px;
      display: block;
    }

    .enterprise-name-right {
      width: calc(100% - 74px);
      display: block;

      .name {
        width: 100%;
        display: block;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 5px;
      }

      .enterprise-code {
        width: 100%;
        display: block;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }


  .enterprise-value {
    width: 100%;
    display: block;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    padding: 5px 0;
    word-break: break-all;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .enterprise-value2 {
    width: 100%;
    display: block;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    padding: 5px 0;
    word-break: break-all;
  }

  .warning-ul {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 32px;

    .warning-li {
      width: 20%;
      display: flex;
      justify-content: center;
      align-items: center;

      .warning-item {
        width: 77px;
        height: 77px;
        background: linear-gradient(-19deg, rgba(2, 14, 49, 0.38), rgba(1, 45, 177, 0.38));
        border-radius: 9px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;

        .name {
          width: 100%;
          text-align: center;
          font-size: 29px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FF3030;
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .vale {
          width: 100%;
          text-align: center;
          display: block;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .warning-color-FF7301 {
      color: #FF7301 !important;
    }

    .warning-color-FFCC01 {
      color: #FFCC01 !important;
    }

    .warning-color-00DC62 {
      color: #00DC62 !important;
    }

    .warning-color-00E4FF {
      color: #00E4FF !important;
    }
  }
}


@media screen and (max-width: 1600px) {
  .home-enterprise-mian {
    width: 100%;

    .enterprise-name-mian {
      .enterprise-name-ico {
        width: 40px;
        height: 40px;
        display: block;
      }

      .enterprise-name-right {
        .name {
          font-size: 15px;
        }

        .enterprise-code {
          font-size: 8px;
        }
      }
    }


    .enterprise-value {
      font-size: 8px;
    }

    .enterprise-value2 {
      font-size: 8px;
    }


    .warning-ul {
      margin-top: 30px;

      .warning-li {
        .warning-item {
          width: 54px;
          height: 54px;
          border-radius: 5px;

          .name {
            font-size: 20px;
          }

          .vale {
            font-size: 8px;
          }
        }
      }


    }
  }
}
</style>
